// src/pages/ErrorPage.jsx
import React from 'react';

const ErrorPage = () => (
  <div style={{ textAlign: 'center', marginTop: '10%' }}>
    <h1>Oops! Something went wrong.</h1>
    <p>We're sorry, but an unexpected error has occurred.</p>
    <a href="/">Go Home</a>
  </div>
);

export default ErrorPage;